import { render, staticRenderFns } from "./general-images-view.vue?vue&type=template&id=6c77ba05&scoped=true"
import script from "./general-images-view.vue?vue&type=script&lang=js"
export * from "./general-images-view.vue?vue&type=script&lang=js"
import style0 from "./general-images-view.vue?vue&type=style&index=0&id=6c77ba05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c77ba05",
  null
  
)

export default component.exports